import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  image?: ImageProps
  items: ItemProps[]
}

export const BannerCTA = memo(function BannerCTA({ image, items }: Props) {
  if (items.length < 1) {
    return null
  }

  return (
    <Container>
      {image ? <Image {...image} /> : null}

      <Wrapper row wrap>
        {items.map((item, index) => (
          <Item key={index} index={index} {...item} />
        ))}
      </Wrapper>
    </Container>
  )
})

const Container = styled.section`
  overflow: hidden;
  position: relative;
  &:before,
  &:after {
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: 1;
  }
  &:before {
    width: 100%;
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
    opacity: 0.5;
    left: 0;
  }
  &:after {
    width: 0.0625rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight1};
    opacity: 0.15;
    left: 50%;
    transform: translateX(-50%);
  }

  > picture {
    img {
      ${styles.img}
    }
  }

  @media (max-width: 1199px) {
    &:after {
      width: 100%;
      height: 0.0625rem;
      opacity: 0.2;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }
`

const Wrapper = styled(FlexBox)``
